import { useTranslation } from "react-i18next";
import React, { useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import Applet from './Applet';
import dateFnsParseISO from 'date-fns/parseISO';
import dateFnsFormat from 'date-fns/format';
import { getSingleUser } from 'store/slices/personalSlice';

const Overview = ({
  user,
  getSingleUser,
  connections
}) => {
  const {
    t
  } = useTranslation();
  // Extract the complex expression to a separate variable
  const userId = user?.objectId;
  useEffect(() => {
    // Only call getSingleUser if user and user.objectId exist
    if (user && user.objectId) {
      getSingleUser(user.objectId);
    }
  }, [getSingleUser, user, userId]); // Move useMemo hooks to the top, before any early returns

  const pendingOutgoingInvites = useMemo(() => !connections.outgoing || connections.outgoing.length === 0 ? 0 : connections.outgoing.filter(_ => _.status === 'pending').length, [connections.outgoing]);
  const pendingIncomingInvites = useMemo(() => !connections.incoming || connections.incoming.length === 0 ? 0 : connections.incoming.filter(_ => _.status === 'pending').length, [connections.incoming]);
  const inConnections = useMemo(() => connections.incoming && connections.incoming.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).filter(conn => conn.status === 'pending'), [connections.incoming]);
  const outConnections = useMemo(() => connections.outgoing && connections.outgoing.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)).filter(conn => conn.status === 'pending'), [connections.outgoing]); // Don't render if user is not loaded yet

  if (!user || !user.objectId) {
    return <Applet title={t("My Pending Invitations")}>
        <p>{t("No invitations currently.")}</p>
      </Applet>;
  }

  const title = 'My Pending Invitations';
  return <Applet title={title}>

      {connections.outgoing && <p>{t("I have")}<strong>{pendingOutgoingInvites}</strong>{t("outgoing invitation")}{pendingOutgoingInvites !== 1 ? 's' : ''}{pendingOutgoingInvites === 0 ? '.' : ':'}</p>}
      <ol>{outConnections && outConnections.map(({
        objectId,
        fullName,
        email,
        createdAt
      }) => {
        const isodate = dateFnsParseISO(createdAt);
        const date = `${dateFnsFormat(isodate, 'PP')}`;
        return <li key={objectId}><strong>{fullName || email}</strong>{t("- sent")}{date}</li>;
      })}
      </ol>
      {connections.incoming && <p>{t("I have")}<strong>{pendingIncomingInvites}</strong>{t("incoming invitation")}{pendingIncomingInvites !== 1 ? 's' : ''}{t("to connect")}{pendingIncomingInvites === 0 ? '.' : ':'}</p>}
      <ol>
        {inConnections && inConnections.map(({
        objectId,
        fullName,
        email,
        createdAt
      }) => {
        const isodate = dateFnsParseISO(createdAt);
        const date = `${dateFnsFormat(isodate, 'PP')}`;
        return <li key={objectId}><strong>{fullName || email}</strong>{t("- sent")}{date}</li>;
      })}
      </ol>

      <hr />
      <p>{t("Use our mobile app to manage connections and see your invitations.")}</p>
    </Applet>;
};

const mapStateToProps = state => ({
  user: state.auth.currentUser,
  connections: state.auth.connections
});

const mapDispatchToProps = dispatch => ({
  getSingleUser: user => dispatch(getSingleUser(user))
});

export default connect(mapStateToProps, mapDispatchToProps)(Overview);